export default "__VITE_ASSET__BvXQSQkJ__"